import React, { ReactNode, forwardRef, useImperativeHandle } from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";

import XHFormInput from "../FormInput";
import "./index.scss";
import { verifyIdcard } from "../../utils";
import { XHComponentCommonProps } from "../../types";

export type IDNumberInputProps = {
  showScan?: boolean;
  label?: string;
  onChange?: (value: string) => void;
  value: string;
  placeholder?: string;
  readOnly?: boolean;
  disabled?: boolean;
  direction?: "column" | "row";
  onScan?: () => void;
  onError?: (msg: string) => void;
  maxlength?: number;
  slot?: ReactNode;
  border?: boolean;
  onBlur?: () => void;
  dataTrackId?: string;
} & XHComponentCommonProps;

export type IDNumberInputRef = {
  isValid: boolean;
  focus: () => void;
};

const BankCardNumberInput = forwardRef<IDNumberInputRef, IDNumberInputProps>(
  (props, fromRef) => {
    const {
      showScan = false,
      label,
      value,
      readOnly,
      direction = "column",
      onScan,
      placeholder = "请输入身份证",
      onError,
      onChange,
      maxlength = 23,
      slot,
      className,
      border,
      onBlur,
      dataTrackId = "xh-idnumber",
    } = props;

    const handleBlur = value => {
      onBlur?.();
      if (!verifyIdcard(value))
        onError?.(value === "" ? "身份证号不能为空" : "请输入正确的身份证号");
    };

    const handleChange = value => {
      const newValue = value.replace(/\s/g, "");

      onChange?.(newValue);
    };

    const handleOnScan = () => {
      onScan?.();
    };

    useImperativeHandle(fromRef, () => {
      return {
        isValid: verifyIdcard(value.replace(/\s/g, "")),
        focus: () => {
          if (typeof fromRef === "object") {
            fromRef?.current?.focus();
          }
        },
      };
    });

    return (
      <View className={classNames("xh-idnumber-input", className)}>
        <XHFormInput
          dataTrackId={dataTrackId}
          padding
          ref={fromRef}
          RightComponent={
            showScan && (
              <View
                onClick={handleOnScan}
                className="xh-idnumber-input-scan"
              ></View>
            )
          }
          border={border}
          direction={direction}
          label={label}
          maxlength={maxlength}
          placeholder={placeholder}
          readonly={readOnly}
          type={process.env.TARO_ENV === "weapp" ? "idcard" : "text"}
          value={value.replace(/\s/g, "")}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        {slot && (
          <View
            className="xh-idnumber-input-slot"
            // @ts-ignore
            dataTrackId={`${dataTrackId}-slot`}
          >
            {slot}
          </View>
        )}
      </View>
    );
  }
);

export default BankCardNumberInput;
